'use client';

import { CountDownTimerExclusive } from '@/app/components/zones/layouts/exclusive-pre-launch/subcomponents/countdown';
import { classes } from '@/utils/classes/classes';
import { RichTextParagraph } from '@/app/components/rich-text/subcomponents/paragraph';
import type { RichTextElement } from '@/app/components/rich-text/rich-text.types';

import './styles/default.scss';

type PopupContentProps = {
    announcementImage?: string;
    headlineLogo?: string;
    launchDate: string;
    counterBackground?: string;
    isPostLaunch: boolean;
    description?: RichTextElement;
    isEarlyAccess: boolean;
    children?: React.ReactNode;
};

export const PopupContent: React.FC<PopupContentProps> = ({
    announcementImage,
    headlineLogo,
    launchDate,
    counterBackground,
    isPostLaunch,
    description,
    isEarlyAccess,
    children
}) => {
    const shouldSwapPositionsPreLaunch = !isPostLaunch && isEarlyAccess;

    const timerComponent = !isPostLaunch ? (
        <CountDownTimerExclusive launchDate={launchDate} offset={23} url={counterBackground} size="medium" />
    ) : null;

    const descriptionComponent =
        isPostLaunch && description ? <RichTextParagraph {...description} className="description" /> : null;

    const headlineLogoElement = headlineLogo ? (
        <div className="exclusive-headline-logo-container">
            <img className="exclusive-headline-logo" alt="headline logo" src={headlineLogo} />
        </div>
    ) : null;

    const announcementLogoElement = announcementImage ? (
        <img className="announcement-label-logo" alt="" src={announcementImage} />
    ) : null;

    const showHeadlineOutside = isEarlyAccess;
    const showAnnouncementOutside = !isEarlyAccess;
    const columnClassName = classes('column', shouldSwapPositionsPreLaunch && 'column--early-access-pre-launch');

    return (
        <div className="exclusive-content">
            {showHeadlineOutside && headlineLogoElement}
            {showAnnouncementOutside && announcementLogoElement}
            <div className="inner-content">
                <div className={columnClassName}>
                    {!showAnnouncementOutside && announcementLogoElement}
                    {showAnnouncementOutside && headlineLogoElement}
                    {showAnnouncementOutside && timerComponent}
                    {shouldSwapPositionsPreLaunch && timerComponent}
                </div>
                {children}
                <div className="info-container">{descriptionComponent}</div>
            </div>
        </div>
    );
};
